module.exports = __webpack_public_path__ + "img/signup-carousel-fifth@2x.354f9efb.png";